import { contractsCompleteSigning } from "@/orval/gen"
import { Center, Stack, Text } from "@mantine/core"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/contract-signing/$contractId/signed")({
  validateSearch: (search: { workflowId: number; event: string }) => search,
  loaderDeps: ({ search: { workflowId, event } }) => ({ workflowId, event }),
  loader: async ({ deps: { workflowId, event }, params: { contractId } }) => {
    if (workflowId !== undefined && event === "signing_complete") {
      await contractsCompleteSigning({
        contractId: parseInt(contractId),
        workflowId: workflowId,
      })
    }
  },
  pendingComponent: PendingComponent,
  component: RouteComponent,
})

function PendingComponent() {
  return <Center h={"100%"}>Signing finalization...</Center>
}

function RouteComponent() {
  return (
    <Center h={"100%"}>
      <Stack align="center">
        <Text>Document signed!</Text>
        <Text>You can exit this page.</Text>
      </Stack>
    </Center>
  )
}
